<template>
  <div>
    <b-card>
      <b-row>
        <b-col sm="4" v-show="operadorRetaguarda">
          <b-form-group label="Operador Retaguarda">
            <input-select
              v-model="model.operadorRetaguarda"
              placeholder="Todos"
              :options="operadores"
              single
            />
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group label="Parceiro">
            <input-select
              v-model="model.parceiro"
              placeholder="Todos"
              :options="parceiros"
              :disabled="!model.operadorRetaguarda && operadorRetaguarda"
              single
            />
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group label="Subparceiro">
            <input-select
              v-model="model.subparceiro"
              placeholder="Todos"
              :options="listaSubparceiro"
              single
              :disabled="!model.parceiro"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="3">
          <b-form-group label="Situacão">
            <input-select
              v-model="model.situacao"
              placeholder="Todos"
              :options="$api.Arrays.TiposSituacao"
              single
            />
          </b-form-group>
        </b-col>
        <b-col sm="3" v-show="conta">
          <b-form-group label="Conta">
            <input-select
              v-model="model.conta"
              placeholder="Todos"
              :options="contas"
              :disabled="!model.subparceiro"
              single
            />
          </b-form-group>
        </b-col>
        <b-col sm="3">
          <b-form-group :label="dtIniText">
            <kendo-datepicker
              v-model="model.datainicial"
              v-mask="'##/##/####'"
              :format="'dd/MM/yyyy'"
              required
            ></kendo-datepicker>
          </b-form-group>
        </b-col>
        <b-col sm="3">
          <b-form-group :label="dtFimText">
            <kendo-datepicker
              v-model="model.datafinal"
              v-mask="'##/##/####'"
              :format="'dd/MM/yyyy'"
              required
            ></kendo-datepicker>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Object },
    dtIniText: { type: String, default: "Data Inicial" },
    dtFimText: { type: String, default: "Data Final" },
    operadorRetaguarda: { type: Boolean, default: false },
    conta: { type: Boolean, default: false },
  },
  data() {
    return {
        parceiros: [],
        listaSubparceiro: [],
        contas: [],
        operadores: []
    };
  },
  computed: {
    model: {
      get() {
        var obj = this.value;
        return obj;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  watch: {
    "model.parceiro": function(val) {
      let th = this
      if(val){
        th.listaSubparceiro = []
        th.ListarSubparceiro()
      }
    },
    "model.operadorRetaguarda": function(val) {
      let th = this
      th.parceiros = []
      if(val){
        th.ListarParceiroPorOperadoresRetaguarda()
      }
    },
    "model.subparceiro": function(val) {
      let th = this
      th.contas = []
      th.ListarContasSubparceiro()
    },
    "model.situacao": function(val) {
      let th = this
      if(th.model.subparceiro){
        th.contas = []
        th.ListarContasSubparceiro()
      }
    },
  },

  methods: {
    ListarSubparceiro(){
      let th = this
      let dto = {parameters: [{ name: 'codigoParceiro', value: th.model.parceiro }]}

      th.$api.Subparceiro.Listar(dto).then(function (data) {
        if (!Array.isArray(data)) return;
    
        data.forEach(function(item) {
          th.listaSubparceiro.push({
            value: item.codigo,
            text: item.nome 
          })
        });
      });
    },
    ListarContasSubparceiro(){
      let th = this
      let dto = {
        parameters:[
            { name: 'codigoSubparceiro', value: th.model.subparceiro },
            { name: 'situacao', value: th.model.situacao }
        ]
      }

      th.$api.SubparceiroConta.GetAll(dto).then(function (data) {
        if (!Array.isArray(data)) return;
    
        data.forEach(function(item) {
          th.contas.push({
            value: item.codigoConta,
            text: item.descricao 
          })
        });
      });
    },
    ListarParceiroPorOperadoresRetaguarda(){
        let th = this
        let dto = {parameters: [{ name: 'codigoOperador', value: th.model.operadorRetaguarda }]}

        th.$api.OperadorRetaguardaParceiro.GetAll(dto).then(function (data) {
          if (!Array.isArray(data)) return;
        
          data.forEach(function(item) {
            th.parceiros.push({
              value: item.codigoParceiro,
              text: item.parceiro 
            })
          });
        });
    },
    ListarOperadoresRetaguarda(){
      let th = this
      let search
      th.operadores = []

      let dto = {parameters: [{ name: 'filter', value: search }]}

      th.$api.OperadoresRetaguarda.GetAll(dto).then(function (data) {
        if (!Array.isArray(data)) return;
        
        data.forEach(function(item) {
          let documentoFederalFormatado = th.$api.UI.Format.DocumentoFederal(item.documentoFederal)
          
          th.operadores.push({
            value: item.codigo,
            text: `${item.nome} (CPF: ${documentoFederalFormatado})`
          })
        });
      });
    },
    ListarParceiros(){
      let th = this
      th.parceiros = []
      th.$set(th.model, 'parceiro', null)

      th.$api.Parceiros.GetAll().then(function (data) {
        if (!Array.isArray(data)) return;
      
        data.forEach(function (item) {
          let parceiro = {
            value: item.codigo,
            text: item.nome.concat(
            ' ',
            '(CNPJ: ',
            th.$api.UI.Format.DocumentoFederal(item.documentoFederal),
            ')'
            )
          }
          th.parceiros.push(parceiro)
        })
      })
    },
    refresh() {
      this.$emit("refresh");
    },
  },
  beforeMount: function () {
    if (this.operadorRetaguarda) this.ListarOperadoresRetaguarda()
    else this.ListarParceiros()
  }
};
</script>
